import { useCallback, useEffect } from 'react'

import { useBlocker } from '@redwoodjs/router'

import useDisclosure, { UseDisclosureReturn } from './use-disclosure'

export const useUnsavedChangesBlocker = (args: {
  blocker?: ReturnType<typeof useBlocker>
  confirmationModalState?: UseDisclosureReturn
  hasUnsavedChanges: boolean
  onDiscardChanges?: () => void
  onKeepEditing?: () => void
}) => {
  const {
    blocker: controlledBlocker,
    confirmationModalState: controlledConfirmationModalState,
    hasUnsavedChanges,
    onDiscardChanges,
    onKeepEditing,
  } = args

  const defaultBlocker = useBlocker({ when: controlledBlocker ? false : hasUnsavedChanges })
  const defaultConfirmationModalState = useDisclosure()

  const blocker = controlledBlocker || defaultBlocker
  const confirmationModalState = controlledConfirmationModalState || defaultConfirmationModalState

  const handleKeepEditingClicked = useCallback(() => {
    blocker.abort()
    confirmationModalState.close()
    onKeepEditing?.()
  }, [blocker, confirmationModalState, onKeepEditing])

  const handleDiscardChangesClicked = useCallback(() => {
    blocker.confirm()
    confirmationModalState.close()
    onDiscardChanges?.()
  }, [blocker, confirmationModalState, onDiscardChanges])

  useEffect(() => {
    if (blocker.state === 'BLOCKED') {
      confirmationModalState.open()
    }
  }, [blocker.state, confirmationModalState])

  return {
    confirmationModalState,
    handleDiscardChangesClicked,
    handleKeepEditingClicked,
  }
}
